import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LiveWeightArea } from 'src/common/components/live-weight-area/live-weight-area';
import { CashierPreferences } from 'src/common/interfaces/dtos/CashierPreferences';
import { AppState } from 'src/common/redux/configure-store';
import { MenuPanelActions } from 'src/common/redux/reducers/menu-panel-reducer';
import MenuButton from 'src/top-area-button/menu-button';
import { TopAreaMiddleButtonTypes } from 'src/top-area/enums/top-area-button-types';
import VerticalCenter from 'src/vertical-center/vertical-center';
import { styles } from './top-area-layout-styles';
import ThemeLogo from 'src/common/components/theme-logo/theme-logo';

const TopAreaLayout: React.FC<ITopAreaProps> = ({
  middleButtons,
  rightButtons,
  isSummaryDisabled,
  cashierPreferences,
}: ITopAreaProps): JSX.Element => {
  const leftHanded = cashierPreferences.leftHanded;
  const classes = styles({ leftHanded });

  const trainingModeActive = useSelector((state: AppState): boolean => state.posMode.trainingMode);

  const dispatch = useDispatch();
  const toggleMenuPanel = (): void => {
    dispatch(MenuPanelActions.toggle());
  };

  return (
    <Box className={`${classes.topArea}`}>
      <Grid container alignItems='center' wrap='nowrap' justifyContent='space-between'>
        <Grid item xs='auto'>
          <Grid container alignItems='center' justifyContent='space-between' wrap='nowrap'>
            <Grid item>
              <MenuButton
                cashierPreferences={cashierPreferences}
                onClick={toggleMenuPanel}
                trainingModeActive={trainingModeActive}
              />
            </Grid>
            <Grid item className={classes.retailerLogoContainer}>
              <ThemeLogo styles={classes.retailerLogo} />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems='center'
          justifyContent='space-between'
          wrap='nowrap'
          className={classes.rightArea}
        >
          <Grid item className={classes.liveWeightContainer} container>
            <LiveWeightArea
              isReversed={leftHanded}
              isLeftHanded={leftHanded}
              isSummaryDisabled={isSummaryDisabled}
            />
          </Grid>
          <Grid item>
            <Grid container className='ltr' justifyContent='flex-end' wrap='nowrap'>
              {middleButtons.map(
                (MiddleButton, index): JSX.Element => {
                  // TODO Removing gift card button until gift receipts feature is implemeneted.
                  if (MiddleButton.key === TopAreaMiddleButtonTypes.ShowGiftCardsCommand) {
                    return <React.Fragment key={index} />;
                  }
                  return (
                    <Grid item className={classes.buttonItem} key={index}>
                      <VerticalCenter>{MiddleButton}</VerticalCenter>
                    </Grid>
                  );
                },
              )}
            </Grid>
          </Grid>
          <Grid item>
            <Grid
              container
              wrap='nowrap'
              justifyContent={leftHanded ? 'flex-start' : 'flex-end'}
              className={'ltr'}
            >
              {rightButtons.map(
                (TopButton, index): JSX.Element => {
                  return (
                    <Grid item className={classes.buttonItem} key={index}>
                      <VerticalCenter>{TopButton}</VerticalCenter>
                    </Grid>
                  );
                },
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export interface ITopAreaProps {
  rightButtons: JSX.Element[];
  middleButtons: JSX.Element[];
  isSummaryDisabled: boolean;
  cashierPreferences: CashierPreferences;
}

export default TopAreaLayout;
